import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoadingState } from 'types/type.global';

const initialState: ILoadingState = {
    isLoading: false,
};
const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});

export const { setIsLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
